import { useState, useEffect } from "react"
import Form from 'react-bootstrap/Form'
import Button from '@mui/material/Button'
import Modal from 'react-bootstrap/Modal'
import InputGroup from 'react-bootstrap/InputGroup'
import CustomSelect from '../../../Components/Form/CustomSelect';
import { Control, SettingsGroup } from "../Modules/General"

import FontModule from "../Modules/FontModule"
import VariableModule from "../Modules/VariableModule"
import CoordinateModule from "../Modules/CoordinateModule"

import * as Basic from "../Modules/BasicFields"

const textVariables = [
    { name: 'Value', key: 'value', type: 'R' },
]

export default function TextProperties(props) {
    const layers = props.layers
    const setLayers = props.setLayers
    const layersCfg = props.layersCfg
    const selected = props.selected
    const selectedIdx = props.selectedIdx
    const modalOpen = props.modalOpen
    const accountType = props.accountType
    const reset = props.reset

    const selectedCoords = props.selectedCoords
    const setSelectedCoords = props.setSelectedCoords
    const setManualSelectedCoords = props.setManualSelectedCoords

    const [name, setName] = useState(null)
    const [placeHolder, setPlaceHolder] = useState(null)
    const [source, setSource] = useState(null)
    const [context, setContext] = useState(null)
    const [feed, setFeed] = useState(null)
    const [rank, setRank] = useState(null)
    const [hashtag, setHashtag] = useState(null)
    const [preset, setPreset] = useState(null)

    const [font, setFont] = useState(null)
    const [variables, setVariables] = useState(null)

    const requiredData = [
        name,
        placeHolder,
        source,
        context,
        feed,
        rank,
        hashtag,
        preset,
        font,
        variables
    ]

    const reload = () => {
        if (selectedIdx < 0) {
            return;
        }

        if (!layersCfg.current[selected]) {
            return
        }

        let properties = layersCfg.current[selected].properties

        if (properties == null) {
            properties = {}
        }

        let n = layersCfg.current[selected].name
        setName( n || "")

        let p = layersCfg.current[selected].place_holder
        setPlaceHolder( p || "")

        setSource(properties.source || "preset")
        setContext(properties.context || "raw")
        setFeed(properties.feed || "username")
        setRank(properties.rank || 0)
        setHashtag(properties.hashtag || "")
        setPreset(properties.preset || "")
        setFont(properties.font || {})
        setVariables(properties.variables || {})
    }

    useEffect(() => {
        reload()
    }, [])

    useEffect(() => {
        reload()
    }, [selected])

    useEffect(() => {
        if( requiredData.includes(null) )
        {
            return
        }

        var data = {
            source: source,
            context: context,
            feed: feed,
            rank: rank,
            hashtag: hashtag,
            preset: preset,
            font: font,
            variables: variables
        }

        layersCfg.current[selected].properties = data
        layersCfg.current[selected].name = name
        layersCfg.current[selected].place_holder = placeHolder

        setLayers([...layers])

    }, [source, context, feed, rank, hashtag, preset, font, variables, name, placeHolder])

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <>
            <CoordinateModule coordinates={selectedCoords}
                setCoordinates={setSelectedCoords}
                selected={selected}
                setManual={setManualSelectedCoords}
            />

            <SettingsGroup name="Data source">
                {source &&
                <Basic.SelectInput name="Source"
                                   value={source}
                                   setValue={setSource}
                                   options={[
                                        { label: "Preset", value: "preset" },
                                        { label: "Variable", value: "variable" }
                                   ]}
                />
                }
                {source == "variable" &&
                <Basic.SelectInput name="Context"
                                   value={context}
                                   setValue={setContext}
                                   options={[
                                        { label: "Raw", value: "raw" },
                                        { label: "Username", value: "username" },
                                        { label: "Message", value: "message" },
                                   ]}
                />
                }
                <Basic.StringInput name="Place holder"
                                   value={preset}
                                   setValue={setPreset}
                />
                {(source == "variable") &&
                <VariableModule variables={variables}
                                setVariables={setVariables}
                                variableList={textVariables}
                                reset={reset}
                />
                }
                {(source == "hashtag") &&
                <Basic.StringInput name="Hashtag" 
                                   value={hashtag}
                                   setValue={setHashtag}
                />
                }

            </SettingsGroup>

            <FontModule font={font}
                        setFont={setFont}
                         iselected={selected}
            />
        </>
    )
}

